// The analyses of the current project: each listed, enabled when it applies
// to the project and disabled with its reason when it does not.
import { useMemo } from "react";
import { useOptionalHistory } from "../context/HistoryContext";
import { FEASIBILITY_ANALYSES } from "./sections";

export default function useFeasibilityAnalyses() {
  const history = useOptionalHistory();
  const cfg = history?.present;
  return useMemo(() => {
    return FEASIBILITY_ANALYSES.map((a) => {
      const enabled = a.applies(cfg);
      return { ...a, enabled, reason: enabled ? "" : a.unavailable };
    });
  }, [cfg]);
}
